import { render, staticRenderFns } from "./BlockType13Grid.vue?vue&type=template&id=4011efec&scoped=true"
import script from "./BlockType13Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType13Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType13Grid.vue?vue&type=style&index=0&id=4011efec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011efec",
  null
  
)

export default component.exports